import { render, staticRenderFns } from "./MyTransfer.vue?vue&type=template&id=ff346772&scoped=true&"
import script from "./MyTransfer.vue?vue&type=script&lang=js&"
export * from "./MyTransfer.vue?vue&type=script&lang=js&"
import style0 from "./MyTransfer.vue?vue&type=style&index=0&id=ff346772&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff346772",
  null
  
)

export default component.exports